module.exports = __webpack_public_path__ + "img/austin1.9734e145.png";